import { GuideDocument } from '../help/GuideDocument.js';
import { WORKFLOW_DOC } from '../help/workflowDoc.js';

/**
 * The workflow document is the same for both sides: it is written to be handed to
 * USPS, either as the Word copy or printed from here.
 */
export function WorkflowDocPage() {
  return (
    <GuideDocument
      guide={WORKFLOW_DOC}
      fileName="VGS-USPS-Work-Order-Management-Workflow.docx"
      showPrint
    />
  );
}
